import React, { Component } from 'react';
import { Container, Header, Segment, Button, Icon } from 'semantic-ui-react';

class Introduction extends Component {
  render() {
    const { tittel, ingress, tekst, kampanje, fradrag, history } = this.props;

    return (
      <Container text textAlign="center">
        <Header as="h1">
          <span dangerouslySetInnerHTML={{ __html: tittel }} />
        </Header>

        <Segment basic size="huge">
          {ingress}
          <Segment basic>{tekst}</Segment>
          <Button
            color="yellow"
            size="huge"
            onClick={() => history.push('/innmelding')}
          >
            Bli medlem <Icon name="angle right" />
          </Button>
        </Segment>

        <Segment basic compact className="kampanje-wrapper">
          <Segment circular inverted compact className="kampanje-sirkel">
            <Header as="h2" inverted>
              {kampanje[0]}
              <Header.Subheader>{kampanje[1]}</Header.Subheader>
            </Header>
          </Segment>
        </Segment>

        <Segment basic size="tiny">
          <span dangerouslySetInnerHTML={{ __html: fradrag }} />
        </Segment>
      </Container>
    );
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/LandingPage/Introduction.js